"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var GoogleAPI = require("@google/maps");
var reactive_google_map_1 = require("@dotdev/reactive-google-map");
var component_1 = require("./component");
var utility_1 = require("./utility");
var ClickAndCollect = /** @class */ (function () {
    function ClickAndCollect(options) {
        var _this = this;
        this.options = options;
        this.markers = [];
        this.query = {
            position: null,
            limit: 10,
            search: "",
            query: null,
        };
        this.tasklock = {};
        this.updateLocations = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.tasker(function () { return __awaiter(_this, void 0, void 0, function () {
                        var position, _a, selectedMarkerStillAvailable;
                        var _this = this;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!this.query.position) {
                                        position = this.googleMapClient.mapGetCenter();
                                        if (position) {
                                            return [2 /*return*/, this.updateQuery({
                                                    position: position,
                                                })];
                                        }
                                    }
                                    _a = this;
                                    return [4 /*yield*/, this.fetchData()];
                                case 1:
                                    _a.markers = _b.sent();
                                    if (this.options.onUpdateLocations) {
                                        this.options.onUpdateLocations();
                                    }
                                    selectedMarkerStillAvailable = this.markers.find(function (marker) { return marker.id === _this.selected; });
                                    if (!selectedMarkerStillAvailable) {
                                        this.selectClear();
                                    }
                                    return [4 /*yield*/, new Promise(function (r) { return setTimeout(function () { return r(); }, 500); })];
                                case 2:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, "marker")];
            });
        }); };
        this.updateQuery = function (query) {
            _this.query = __assign({}, _this.query, query);
            if (_this.options.onUpdateQuery) {
                _this.options.onUpdateQuery();
            }
            return _this.updateLocations();
        };
        this.tasker = function (task, lock) {
            if (lock === void 0) { lock = "global"; }
            return __awaiter(_this, void 0, void 0, function () {
                var next;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.tasklock[lock] && this.tasklock[lock].busy === true) {
                                this.tasklock[lock].next = task;
                                return [2 /*return*/];
                            }
                            this.tasklock[lock] = {
                                busy: true,
                                next: null,
                            };
                            return [4 /*yield*/, task()];
                        case 1:
                            _a.sent();
                            if (!this.tasklock[lock].next) return [3 /*break*/, 3];
                            next = this.tasklock[lock].next;
                            this.tasklock[lock].next = null;
                            return [4 /*yield*/, next()];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            this.tasklock[lock].busy = false;
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var result, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.options.fetchData) return [3 /*break*/, 1];
                        result = this.options.fetchData(this.query);
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, fetch(this.options.endpoint.locations, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(this.query),
                        })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (this.options.formatData) {
                            result = this.options.formatData(result);
                        }
                        if (this.options.filterResult) {
                            result = result.filter(function (item) { return _this.options.filterResult(item); });
                        }
                        if (this.options.formatResult) {
                            result = result.map(function (item) { return _this.options.formatResult(item); });
                        }
                        return [2 /*return*/, result];
                }
            });
        }); };
        this.setProvider = function (provider) {
            _this.provider = provider;
        };
        this.setGoogleMapClient = function (googleMapClient) {
            _this.googleMapClient = googleMapClient;
        };
        this.setGoogleMapAutocompleteClient = function (googleMapAutocompleteClient) {
            _this.googleMapAutocompleteClient = googleMapAutocompleteClient;
        };
        this.selectMarker = function (marker) {
            _this.selected = marker.id;
            _this.googleMapClient.mapPanTo(marker.position);
            if (_this.googleMapClient.mapGetZoom() < 14) {
                _this.googleMapClient.mapZoomTo(14);
            }
            _this.googleMapClient.infowindowOpen(marker);
            _this.provider.setState({});
        };
        this.selectClear = function () {
            _this.selected = null;
            _this.googleMapClient.infowindowClose();
            _this.provider.setState({});
        };
        /** Queries Shopify AJAX Cart API for all product variant id's and sends a request to the [[ClickAndCollect.Options.endpoint.stock]] endpoint with all items in the cart. */
        this.checkStock = function (locationId) {
            if (locationId === void 0) { locationId = _this.selected; }
            return __awaiter(_this, void 0, void 0, function () {
                var lineItems, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!locationId) {
                                throw new Error("No Location is set or provided.");
                            }
                            return [4 /*yield*/, utility_1.ShopifyCart.LineItemsRead()];
                        case 1:
                            lineItems = _a.sent();
                            if (!lineItems || !lineItems.length) {
                                return [2 /*return*/, null];
                            }
                            return [4 /*yield*/, fetch(this.options.endpoint.stock, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify({
                                        location: locationId,
                                        items: lineItems.map(function (lineItem) { return lineItem.sku; }),
                                    }),
                                })];
                        case 2:
                            response = _a.sent();
                            return [2 /*return*/, response.json()];
                    }
                });
            });
        };
        this.geocoder = new reactive_google_map_1.Geocoder({
            googleMapsApiKey: this.options.googleMapsApiKey,
            googleMapsApiVersion: this.options.googleMapsApiVersion,
        });
    }
    ClickAndCollect.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.googleApiClient = GoogleAPI.createClient({
                    key: this.options.googleMapsApiKey,
                    Promise: Promise,
                });
                return [2 /*return*/];
            });
        });
    };
    ClickAndCollect.Provider = component_1.ClickAndCollectProvider;
    ClickAndCollect.Search = component_1.ClickAndCollectSearch;
    ClickAndCollect.Map = component_1.ClickAndCollectMap;
    ClickAndCollect.List = component_1.ClickAndCollectList;
    ClickAndCollect.Geolocate = component_1.ClickAndCollectGeolocate;
    ClickAndCollect.Cart = utility_1.ShopifyCart;
    return ClickAndCollect;
}());
exports.ClickAndCollect = ClickAndCollect;
//# sourceMappingURL=click-and-collect.js.map